import $ from 'jquery';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import React, { Component, PropTypes } from 'react';

import AttributeSelectionWidget from './AttributeSelectionWidget';
import QuantityInput from './QuantityInput';
import * as queryString from 'query-string';
import {compareAttributes} from '../../utils';

export default observer(
  class VariantPicker extends Component {
    static propTypes = {
      onAddToCartError: PropTypes.func.isRequired,
      onAddToCartSuccess: PropTypes.func.isRequired,
      store: PropTypes.object.isRequired,
      url: PropTypes.string.isRequired,
      variantAttributes: PropTypes.array.isRequired,
      variants: PropTypes.array.isRequired,
      sizeChart: PropTypes.string
    };

    constructor(props) {
      super(props);
      const { variants } = this.props;
      const variant = variants.filter(v => !!Object.keys(v.attributes).length && v.availability)[0] || variants.filter(v => !!Object.keys(v.attributes).length)[0];
      const params = queryString.parse(location.search);
      let selection = {};
      if (Object.keys(params).length) {
        Object.keys(params).some(name => {
          const valueName = params[name];
          const attribute = this.matchAttributeBySlug(name);
          const value = this.matchAttributeValueByName(attribute, valueName);
          if (attribute && value) {
            selection[attribute.pk] = value.pk.toString();
          } else {
            // if attribute doesn't exist - show variant
            selection = variant ? variant.attributes : {};
            // break
            return true;
          }
        });
      } else if (variant && Object.keys(variant).length) {
        selection = variant.attributes;
      }
      this.state = {
        errors: {},
        quantity: 1,
        selection: selection
      };
      this.matchVariantFromSelection();
    }

    checkVariantAvailability = () => {
      const { store } = this.props;
      return store.variant.availability;
    };

    handleAddToCart = () => {
      const { onAddToCartSuccess, onAddToCartError, store } = this.props;
      const { quantity } = this.state;
      this.setState({
        status: 'adding'
      });
      if (quantity > 0 && !store.isEmpty) {
        $.ajax({
          url: this.props.url,
          method: 'post',
          data: {
            quantity: quantity,
            variant: store.variant.id
          },
          success: () => {
            this.setState({
              status: 'added'
            });
            window.setTimeout(
              () =>
                this.setState({
                  status: null
                }),
              5000
            );
            onAddToCartSuccess();

            if (window.pintrk) {
              window.pintrk('track', 'addtocart', {
                value: store.variant.price.gross,
                order_quantity: quantity,
                currency: store.variant.price.currency
              });
            }
          },
          error: response => {
            onAddToCartError(response);
          }
        });
      }
    };

    handleAttributeChange = (attrId, valueId) => {
      this.setState(
        {
          selection: Object.assign({}, this.state.selection, { [attrId]: valueId })
        },
        () => {
          this.matchVariantFromSelection();
          let params = {};
          Object.keys(this.state.selection).forEach(attrId => {
            const attribute = this.matchAttribute(attrId);
            const value = this.matchAttributeValue(attribute, this.state.selection[attrId]);
            if (attribute && value) {
              params[attribute.slug] = value.slug;
            }
          });
          history.pushState(null, null, '?' + queryString.stringify(params));
        }
      );
    };

    handleQuantityChange = event => {
      this.setState({ quantity: parseInt(event.target.value) });
    };

    matchAttribute = id => {
      const { variantAttributes } = this.props;
      const match = variantAttributes.filter(attribute => attribute.pk.toString() === id);
      return match.length > 0 ? match[0] : null;
    };

    matchAttributeBySlug = slug => {
      const { variantAttributes } = this.props;
      const match = variantAttributes.filter(attribute => attribute.slug === slug);
      return match.length > 0 ? match[0] : null;
    };

    matchAttributeValue = (attribute, id) => {
      const match = attribute.values.filter(attribute => attribute.pk.toString() === id);
      return match.length > 0 ? match[0] : null;
    };

    matchAttributeValueByName = (attribute, name) => {
      const match = attribute ? attribute.values.filter(value => value.slug === name) : [];
      return match.length > 0 ? match[0] : null;
    };

    matchVariantFromSelection() {
      const { store, variants } = this.props;
      let matchedVariant = null;
      variants.forEach(variant => {
        if (compareAttributes(this.state.selection, variant.attributes)) {
          matchedVariant = variant;
        }
      });
      store.setVariant(matchedVariant);
    }

    render() {
      const { store, variantAttributes, variants } = this.props;
      const { errors, selection, quantity, status } = this.state;
      const disableAddToCart = store.isEmpty || !this.checkVariantAvailability();

      const addToCartBtnClasses = classNames({
        'btn primary': true,
        disabled: disableAddToCart
      });

      return (
        <div>
          {variantAttributes.map((attribute, i) => (
            <AttributeSelectionWidget
              attribute={attribute}
              variants={variants}
              selection={selection}
              handleChange={this.handleAttributeChange}
              key={i}
              selected={selection[attribute.pk]}
            />
          ))}
          <div className="clearfix">
            <QuantityInput
              errors={errors.quantity}
              handleChange={this.handleQuantityChange}
              quantity={quantity}
              sizeChart={this.props.sizeChart}
            />
            <div className="form-group product__info__button">
              <button className={addToCartBtnClasses} onClick={this.handleAddToCart} disabled={disableAddToCart}>
                {!status ? pgettext('Product details primary action', 'Add to cart') : status === 'adding' ? 'Adding to cart' : 'Added to cart'}
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
);
